import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-overlay-tree',
  templateUrl: './overlay-tree.component.html',
  styleUrls: ['./overlay-tree.component.scss']
})
export class OverlayTreeComponent implements OnInit {
  @Input() item: any = {};
  @Output() itemChange = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

  itemChanged() {
    this.itemChange.emit(this.item);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/overlay-tree/overlay-tree.component.ts